<template>
  <highliter
    v-model="section.name"
    :section="section"
    :dublicate="section"
    class="highlight-element"
    :class="{'element-hidden': !visability('counter')}"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('counter')"
  >
    <div
      :data-sid="section.sid"
      :data-uid="section.uid"
      :class="`--${section.sid}--wrapper`"
      class="counter flex items-center justify-center"
    >
      <div
        :class="`--${section.sid}--prefix`"
        v-text="section.options.content.counter.prefix.text.lg"
      />
      <template v-show="shapeEnabled && fromVal < toVal">
        <div
          v-for="(digit, index) in getLength - count.length"
          :key="`key-${index}`"
          class="flex items-center justify-center digit"
          :class="`--${section.sid}--digit`"
        >
          <span>0</span>
        </div>
      </template>
      <div
        v-for="(digit, index) in getCount"
        :key="index"
      >
        <div
          v-if="digit !== ','"
          :class="[`--${section.sid}--digit`, {'bg': section.options.content.counter.shapeEnabled}]"
          class="flex items-center justify-center digit"
        >
          <span
            v-text="digit"
          />
        </div>
        <div
          v-else
          class="drop-shadow"
          :class="`--${section.sid}--decimal`"
          v-text="section.options.content.counter.decimal.char"
        />
      </div>
      <div
        :class="`--${section.sid}--postfix`"
        v-text="section.options.content.counter.postfix.text.lg"
      />
    </div>
  </highliter>
</template>

<script>
import _ from 'lodash'
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import BorderMixin from '@/components/mixins/BorderMixin'
import CustomStylesMixin from '@/components/mixins/CustomStylesMixin'

export default {
  name: 'FeaturedItems1',

  components: {Highliter},

  mixins: [SectionMixin, BorderMixin, CustomStylesMixin],

  data () {
    return {
      $scrollContainer: null,
      from: 0,
      to: 0,
      play: false,
      counterValue: 0
    }
  },

  computed: {
    getLength () {
      return this.to.toString().length
    },
    getCount () {
      return this.section.options.content.counter.decimal.enabled.lg ? this.formatedCount : this.count
    },
    formatedCount () {
      return new Intl.NumberFormat().format(this.counterValue).split('')
    },
    count () {
      if (this.counterValue.toString() === 'NaN') return [0]
      return this.counterValue.toString().split('')
    },
    shapeEnabled () {
      let _subject = this.section.options.content.counter.shapeEnabled[this.resolutioner]
      if (_subject === null) {
        _subject = this.section.options.content.counter.shapeEnabled.lg
      }

      return _subject
    },
    speed () {
      return (this.section.options.content.counter.speed || 0.1) * 1000
    },
    fromVal () {
      return this.section.options.content.counter.from
    },
    toVal () {
      return this.section.options.content.counter.to
    }
  },

  watch: {
    play () {
      this.animate()
    },
    fromVal () {
      this.animate()
    },
    toVal () {
      this.animate()
    }
  },

  mounted () {
    this.isInViewPort()

    document.querySelector('.scrollbale-container').addEventListener('scroll', this.isInViewPort)
  },

  beforeDestroy () {
    const $scrollContainer = document.querySelector('.scrollbale-container')
    if (!$scrollContainer) return

    $scrollContainer.removeEventListener('scroll', this.isInViewPort)
  },

  methods: {
    isInViewPort () {
      if (this.play || !this.$el) return
      const bounding = this.$el.getBoundingClientRect()

      if (
        bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      ) {
        this.play = true
        return true
      }
    },
    animate () {
      let startTime = null
      this.from = _.cloneWith(this.section.options.content.counter.from)
      this.to = _.cloneWith(this.section.options.content.counter.to)

      const step = (currentTime) => {
        if (!startTime) {
          startTime = currentTime
        }

        const progress = Math.min((currentTime - startTime) / this.speed, 1)

        this.counterValue = Math.floor(progress * (this.to - this.from) + this.from)

        if (progress < 1) {
          window.requestAnimationFrame(step)
        } else {
          window.cancelAnimationFrame(window.requestAnimationFrame(step))
        }
      }

      window.requestAnimationFrame(step)
    }
  }
}
</script>

<style lang="scss">
.counter {
  --counter-height:20px;
  --counter-width:20px;

  .digit.bg {
    height: calc(var(--counter-size, auto) + var(--counter-height, 0));
    width: calc(var(--counter-size, auto) + var(--counter-width, 0));
  }

  font-size: 22px;
}
</style>
